import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminEmailSignupsPage = () => {
  const [signups, setSignups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchSignups();
  }, []);

  const fetchSignups = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const token = localStorage.getItem('access_token');
      
      if (!token) {
        navigate('/signin');
        return;
      }

      const response = await fetch(`${backendUrl}/api/admin/email-signups`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-Dev-Password': 'secure2025dev'
        }
      });

      if (response.status === 401 || response.status === 403) {
        setError('Admin access required');
        return;
      }

      if (!response.ok) {
        throw new Error('Failed to fetch signups');
      }

      const data = await response.json();
      setSignups(Array.isArray(data?.signups) ? data.signups : []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const exportToCSV = () => {
    const csv = [
      ['First Name', 'Email', 'Signed Up', 'IP Address'],
      ...signups.map(s => [
        s.firstName,
        s.email,
        new Date(s.created_at).toLocaleDateString(),
        s.ip_address || ''
      ])
    ].map(row => row.join(',')).join('\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `email-signups-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-red-400 text-xl">{error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-white">
            Launch Notification Signups
          </h1>
          <div className="flex gap-4">
            <button
              onClick={exportToCSV}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
            >
              Export to CSV
            </button>
            <button
              onClick={() => navigate('/')}
              className="bg-gray-700 hover:bg-gray-600 text-white px-6 py-2 rounded-lg font-medium transition-colors"
            >
              Back to Home
            </button>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg border border-gray-700 p-6">
          <div className="mb-4">
            <p className="text-gray-300 text-lg">
              Total Signups: <span className="text-white font-bold">{signups?.length || 0}</span>
            </p>
            <p className="text-xs text-gray-500 mt-2">
              Privacy Note: This data is private and for your use only. Do not share or sell these email addresses.
            </p>
          </div>

          {!signups || signups.length === 0 ? (
            <p className="text-gray-400 text-center py-8">No signups yet</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-700">
                    <th className="text-left py-3 px-4 text-gray-300 font-medium">First Name</th>
                    <th className="text-left py-3 px-4 text-gray-300 font-medium">Email</th>
                    <th className="text-left py-3 px-4 text-gray-300 font-medium">Signed Up</th>
                    <th className="text-left py-3 px-4 text-gray-300 font-medium">IP Address</th>
                  </tr>
                </thead>
                <tbody>
                  {signups.map((signup) => (
                    <tr key={signup.id} className="border-b border-gray-700 hover:bg-gray-750">
                      <td className="py-3 px-4 text-white">{signup.firstName}</td>
                      <td className="py-3 px-4 text-white">{signup.email}</td>
                      <td className="py-3 px-4 text-gray-300">
                        {new Date(signup.created_at).toLocaleDateString()} {new Date(signup.created_at).toLocaleTimeString()}
                      </td>
                      <td className="py-3 px-4 text-gray-400 text-sm">{signup.ip_address || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminEmailSignupsPage;
